module.exports = __webpack_public_path__ + "static/brush-yellow-line-060649e484b831cffa7c098c563cf35f.png";